import { useUser } from '@clerk/clerk-react';
import { Navigate } from '@tanstack/react-router';
import CoverPage from './CoverPage';

const RootPage = () => {
    // Wait for Clerk to finish loading auth state to avoid a flash of
    // the public cover page before we redirect signed-in users.
    const { isSignedIn, isLoaded } = useUser();

    // Small centered spinner shown while Clerk initializes
    const LoadingSpinner = () => (
        <div className="min-h-screen flex items-center justify-center bg-neutral-50">
            <div className="w-10 h-10 border-4 border-neutral-200 border-t-primary rounded-full animate-spin" />
        </div>
    );

    // If Clerk hasn't finished initializing, show the spinner to avoid flicker.
    if (!isLoaded) return <LoadingSpinner />;

    if (isSignedIn) {
        return <Navigate to="/dashboard" replace />;
    }

    return <CoverPage />;
};

export default RootPage;
